import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const TrainingDocumentsToProcessRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--documents-to-process']}>
    <Route index element={<Index />} />
  </SubRouter>
))
